/**
 * @generated SignedSource<<271df4939a3f94b3a679eedb3fe369f3>>
 * @relayHash 6fd96fa79cd88f4daa1afa95da0e618f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a3cdad9d85a286735d160e36b6fc0ee43535f10938f2aeaa4af8baeaabc58549

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PopupContentQuery } from './PopupContentQuery.graphql';

const node: PreloadableConcreteRequest<PopupContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a3cdad9d85a286735d160e36b6fc0ee43535f10938f2aeaa4af8baeaabc58549",
    "metadata": {},
    "name": "PopupContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
